import http from '../utils/http';
import interpolate from 'pinterpolate';
import { NOTES, NOTES_URL_ID } from '../constants/endpoints';
import type { Note, NoteApiItem, NoteListResponse } from 'interface/note';
import type { ServiceId, ServiceParams } from 'interface/service';

export async function fetchNotes<TNote extends NoteApiItem = NoteApiItem>(params: ServiceParams = {}) {
  return await http.get<NoteListResponse<TNote>>(NOTES, { params: { ...params } });
}

export async function createNote(note: Note) {
  return await http.post(NOTES, { body: note });
}

export async function updateNote(id: ServiceId, note: Note) {
  return await http.put(interpolate(NOTES_URL_ID, { id }), { body: note });
}

export async function fetchNoteById(id: ServiceId) {
  return await http.get(interpolate(NOTES_URL_ID, { id }));
}
